const Builder = require('../BuilderBase');
const createBasicFilter = filterName => {
    return class BasicFilter extends Builder {
        constructor(properties) {
            super(`filter_${filterName}`, '', properties);
        }
    };
};

module.exports = {
    AlsoSearchWithAscii: createBasicFilter('AlsoSearchWithAscii'),
    ByCurrentRoute: createBasicFilter('ByCurrentRoute'),
    ByCurrentUser: createBasicFilter('ByCurrentUser'),
    ByNavigationSelection: createBasicFilter('ByNavigationSelection'),
    ByNavigationSelectionCriteria: createBasicFilter('ByNavigationSelectionCriteria'),
    ByNavigationSelectionDropdownCriteria: createBasicFilter('ByNavigationSelectionDropdownCriteria'),
    DateRange: createBasicFilter('DateRange'),
    PropertiesToSearch: createBasicFilter('PropertiesToSearch'),
    OrderBy: createBasicFilter('OrderBy'),
    ForeignRelationSelectionOnForm: createBasicFilter('ForeignRelationSelectionOnForm'),
    ForeignRelationActiveRecord: createBasicFilter('ForeignRelationActiveRecord'),
    DefaultToPreviousSelection: createBasicFilter('DefaultToPreviousSelection'),
    DefaultValue: createBasicFilter('DefaultValue'),
    NestedListEntry: require('./NestedListEntry')
};
